import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MOCK_STATUS, 
		MOCK_URL_ORIGINS, 
		URL_BFM_LOCATION_ORIGIN, 
		URL_BFM_LOCATION_DESTINATION, 
		MOCK_URL_DESTINATIONS, 
		MOCK_URL_DESTINATIONS_PAY_WITH_MILES_ONLY,
		URL_BFM_LOCATION_ORIGIN_MULTICITY,
		URL_BFM_GEOGRAPHY_CONTINENTS, 
		MOCK_URL_CONTINENTS, 
		URL_BFM_GEOGRAPHY_AIRPORTS, 
		MOCK_URL_AIRPORTS 
		} from '@ibe.config';
		
import { INDRABFMJourneyOriginResponse, 
		INDRAJourneyParam, 
		INDRABFMJourneyDestinationResponse, 
		INDRABFMContinentsResponse, 
		INDRABFMAirportsResponse 
		} from '@ibe.models/airport.indra.model.lib';

@Injectable({
	providedIn: 'root'
})
export class INDRAAirportLocationService {

  origins: Observable<INDRABFMJourneyOriginResponse>;
  destinations: Observable<INDRABFMJourneyDestinationResponse>;
  continents: Observable<INDRABFMContinentsResponse>;
  airports: Observable<INDRABFMAirportsResponse>;

	constructor(private api: INDRAApiService, private http: HttpClient) {
	}

	IndraGetOrigins(params: INDRAJourneyParam): Observable<INDRABFMJourneyOriginResponse> {
		if (MOCK_STATUS.ORIGINS) {
			return this.http.get<INDRABFMJourneyOriginResponse>(MOCK_URL_ORIGINS);
		} else {
			this.origins = this.api.INDRA_post<INDRABFMJourneyOriginResponse>(URL_BFM_LOCATION_ORIGIN, params);
			return this.origins;
		}
  	}

  	IndraGetDestinations(params: INDRAJourneyParam): Observable<INDRABFMJourneyDestinationResponse> {
		if (MOCK_STATUS.DESTINATIONS) {
			let MOCK_URL_PATH = MOCK_URL_DESTINATIONS;
			if (params.payWithMiles) {
				MOCK_URL_PATH = MOCK_URL_DESTINATIONS_PAY_WITH_MILES_ONLY;
			}
			return this.http.get<INDRABFMJourneyDestinationResponse>(MOCK_URL_PATH);
		} else {
			this.destinations = this.api.INDRA_post<INDRABFMJourneyDestinationResponse>(URL_BFM_LOCATION_DESTINATION, params);
			return this.destinations;
		}
	}

	INDRAGetMulticityOrigins(params: INDRAJourneyParam): Observable<INDRABFMJourneyOriginResponse> {
		if (MOCK_STATUS.MULTICITY_ORIGINS) {
			return this.http.get<INDRABFMJourneyOriginResponse>(MOCK_URL_ORIGINS);
		} else {
			this.origins = this.api.INDRA_post<INDRABFMJourneyOriginResponse>(URL_BFM_LOCATION_ORIGIN_MULTICITY, params);
			return this.origins;
		}
	}

	INDRAGetContinents(params): Observable<INDRABFMContinentsResponse> {
		if (MOCK_STATUS.CONTINENTS) {
			return this.http.get<INDRABFMContinentsResponse>(MOCK_URL_CONTINENTS);
		} else {
			this.continents = this.api.INDRA_post<INDRABFMContinentsResponse>(URL_BFM_GEOGRAPHY_CONTINENTS, params);
			return this.continents;
		}
	}

	INDRAGetAirports(params): Observable<INDRABFMAirportsResponse> {
		if (MOCK_STATUS.AIRPORTS) {
			return this.http.get<INDRABFMAirportsResponse>(MOCK_URL_AIRPORTS);
		} else {
			this.airports = this.api.INDRA_post<INDRABFMAirportsResponse>(URL_BFM_GEOGRAPHY_AIRPORTS, params);
			return this.airports;
		}
	}
}

